export const codeOk = 200;
export const codeCreate = 201;
export const codeError = 400;

export const errorMessage = "An Error Occured";
export const emptyFieldMessage = (field) => `${field} is required`;
export const invalidFieldMessage = (field) => `${field} is invalid`;
